<div class="flex flex-col h-full w-full min-h-0">
  <!-- Main carousel container -->
  <div
    #emblaRoot
    [id]="emblaId()"
    class="embla w-full flex-grow min-h-[300px] md:min-h-[400px] items-center flex relative"
  >
    <div class="embla__container">
      @for (slide of files(); track slide.id) {
        <div class="embla__slide relative">
          <!-- Blurred background image -->
          <div class="relative w-full h-full overflow-hidden rounded-md bg-proffeo-surface-inverse">
            @if (slide.isImage()) {
              <!-- Rozmyte tło -->
              <img
                [src]="slide.fullviewUrl()"
                alt="background"
                draggable="false"
                class="absolute inset-0 h-full w-full object-cover opacity-70 blur-md select-none pointer-events-none"
              />
              <!-- Ostry główny obraz -->
              <img
                [src]="slide.fullviewUrl()"
                alt="image"
                referrerpolicy="no-referrer"
                draggable="false"
                class="relative z-10 h-full w-full object-contain"
              />
            } @else if (slide.isVideo()) {
              <video
                [src]="slide.fullviewUrl()"
                [muted]="true"
                playsinline
                controls
                preload="metadata"
                class="absolute inset-0 h-full w-full object-contain z-10"
              ></video>
            } @else if (slide.isPdf()) {
              <iframe
                [src]="toSafePdfUrl(slide.fullviewUrl())"
                title="PDF preview"
                class="absolute inset-0 h-full w-full z-10 bg-proffeo-surface"
              ></iframe>
            }
          </div>
        </div>
      } @empty {
        <div class="embla__slide flex items-center justify-center">
          <p class="text-proffeo-muted">{{ 'placeholders.no-images-to-display' | translate }}</p>
        </div>
      }
    </div>

    <!-- Download button -->
    @if (currentImage()) {
      <proffeo-ui-button
        (clicked)="downloadCurrentFile()"
        [ariaLabel]="'files-list-download' | translate"
        [loading]="isDownloading()"
        [tooltip]="'files-list-download' | translate"
        fontIcon="download"
        size="sm"
        variant="secondary"
        class="absolute right-5 top-5 z-[10]"
      />
    }

    <!-- Counter -->
    <span
      class="rounded z-[10] bg-proffeo-base-900/65 flex items-center justify-center p-1.5 px-2 absolute right-5 bottom-3 transition-all transition-150"
    >
      <p class="text-proffeo-on-action text-sm">{{ index() + 1 }}/{{ files().length }}</p>
    </span>

    <!-- Previous arrow -->
    <span
      (click)="slideLeft()"
      [ngClass]="
        canScrollPrev()
          ? 'hover:bg-proffeo-accent/75 cursor-pointer bg-proffeo-base-alpha-75'
          : 'bg-proffeo-base-900/40 pointer-events-none'
      "
      class="absolute flex items-center justify-center w-10 h-10 z-[10] rounded-full aspect-square left-3 transition-all transition-150 ring-1 ring-proffeo-base-50/20"
    >
      <mat-icon
        fontIcon="chevron_backward"
        class="icon-white"
      />
    </span>

    <!-- Next arrow -->
    <span
      (click)="slideRight()"
      [ngClass]="
        canScrollNext()
          ? 'hover:bg-proffeo-accent/75 cursor-pointer bg-proffeo-base-alpha-75'
          : 'bg-proffeo-base-900/40 pointer-events-none'
      "
      class="absolute flex items-center justify-center w-10 h-10 z-[10] rounded-full aspect-square right-3 transition-all transition-150 ring-1 ring-proffeo-base-50/20"
    >
      <mat-icon
        fontIcon="chevron_forward"
        class="icon-white"
      />
    </span>
  </div>

  <!-- Description section -->
  @if (currentImage()) {
    <div class="w-full px-4 py-3 bg-proffeo-surface-muted flex-shrink-0">
      <div class="flex items-center gap-2 justify-center mb-1.5">
        <div class="text-center text-proffeo-text text-sm">
          {{ currentImage()!.name }}
        </div>
      </div>

      <div class="max-w-3xl mx-auto">
        <proffeo-file-description
          (descriptionChange)="onDescriptionChange($event)"
          [description]="currentImage()!.description"
          [fileId]="currentImage()!.id"
        ></proffeo-file-description>
      </div>
    </div>
  }
</div>
